import React, { Component } from "react";
import ServerWrong from "../500";
import Layout from "layout/Layout";

export default class index extends Component {
  state = {
    error: false,
  };

  componentDidCatch(error, info) {
    this.setState({ error: true });
  }

  componentWillUnmount() {
    this.setState({ error: false });
  }

  render() {
    const { error } = this.state;
    const { children } = this.props;

    if (error) {
      return (
        <Layout>
          <ServerWrong />
        </Layout>
      );
    }
    return children;
  }
}



// WEBPACK FOOTER //
// ./components/ErrorBoundary/index.js